import { variables } from './_variables.js';

export const responsiveAccordion = () => {
  const accordionGroup = document.querySelector('.js-responsive-accordion');
  if (!accordionGroup) return;
  const { isMobile , isUserAgentMobile } = variables();
  const toggleAccordions = () => {
    
    
    const details = accordionGroup.querySelectorAll('details.accordion-content');
    details.forEach(accordion => {
      if (!isMobile) {
        accordion.setAttribute('open', '');
      } else {
        accordion.removeAttribute('open');
      }
    });
  };

  const clickAccordion = () => {
    const details = accordionGroup.querySelectorAll('details.accordion-content');
    
    // アニメーション設定を共通化
    const createAnimation = (content, isClosing = false) => {
      return new Animation(
        new KeyframeEffect(content, {
          maxHeight: isClosing ? ['100vh', '0'] : ['0', '100vh'],
          opacity: isClosing ? [1, 0] : [0, 1]
        }, {
          duration: 300,
          easing: isClosing ? 'ease-out' : 'ease-in'
        })
      );
    };

    details.forEach(accordion => {
      const summary = accordion.querySelector('summary.accordion-trigger');
      const content = accordion.querySelector('.content');
      
      if (!summary || !content) return;

      summary.addEventListener('click', (e) => {
        e.preventDefault();
        summary.classList.toggle('is-open');
        const isClosing = accordion.hasAttribute('open');
        const anim = createAnimation(content, isClosing);
        
        if (isClosing) {
          anim.onfinish = () => accordion.removeAttribute('open');
        } else {
          accordion.setAttribute('open', '');
        }
        
        anim.play();
      });
    });
  };

  // 初期化時
  toggleAccordions();
  clickAccordion();
  
  // リサイズ時 PCのみ
  if (!isUserAgentMobile) {
    window.addEventListener('resize', toggleAccordions);
  }
};